module.exports = __webpack_public_path__ + "static/media/piotech.402877e1.png";